module.exports = __webpack_public_path__ + "fonts/DINCond-Black.f68c6bad.otf";